import Enum from "./Enum";

export default Enum.create( {
	V1: "v1",
	V2: "v2",
} );
